<template>
  <NotificationComponent
    v-show="visible"
    :title="title"
    @close="handleCloseTruckNotification"
  >
    <div class="flex flex-col gap-2 text-left">
      <p class="text-left text-sm font-normal text-steel-900">
        We still haven’t received your cargo policy. To ensure you’re seeing all
        available loads, please ask your insurance agency to send a complete
        cargo policy.
      </p>
      <p
        class="mt-2 cursor-pointer font-medium text-sun-700 underline hover:opacity-90 focus:opacity-80"
        @click="onVerifyCargoPolicy"
      >
        Verify my exclusions
      </p>
    </div>
  </NotificationComponent>
</template>

<script setup>
import { defineProps } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { NotificationComponent } from '@/components';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Success',
  },
});

const store = useStore();
const toast = useToast();

const onVerifyCargoPolicy = async () => {
  try {
    await store.dispatch('insurance/createCargoPolicyRequest');
  } catch (error) {
    console.error('Error verifying cargo policy:', error);
    showErrorToast(error);
  }
};

function showErrorToast(error) {
  toast?.open({
    message:
      error?.response?.data?.[0] ||
      'Something went wrong with your request. Please try again',
    position: 'top-right',
    duration: 5000,
    type: 'error',
  });
}
</script>
